<template>
    <div class="content-center none-click">
      <div class="banner">
        <div class="banner_box">
            <div class="banner_title">千橙数字人 AI创作平台</div>
            <div class="banner_line"></div>
            <div class="banner_title2">千橙数字人是一款基于人工智能和计算机图形学技术，通过模拟还原真人外貌、声音和行为的AI数字分身。使用千橙数字人来进行发布，也可以定制自己的专属数字员工进行品牌推广。</div>
            <!-- <div class="banner_text">企业私域电商直播平台</div> -->
        </div>
        <img src="@/assets/Mobile/images/QcDigit/banner.png" alt="">
      </div>
      <div class="programme programme1">
        <div class="sk-mobile-title">
          <div class="title"><span class="title_text_color">4</span>大核心优势，提高运营效率和服务质量</div>
        </div>
        <div class="content" style="margin-top: 20px;">
            <img src="@/assets/Mobile/images/QcDigit/programme1.png" alt="">
        </div>
      </div>
      <div class="programme">
        <div class="sk-mobile-title">
          <div class="title">仅需4步，高效完成短视频创作</div>
        </div>
        <div class="content" style="margin-top: 30px;">
            <img src="@/assets/Mobile/images/QcDigit/programme2.png" alt="">
            <img style="margin-top: 16px;" src="@/assets/Mobile/images/QcDigit/programme3.png" alt="">
            <img style="margin-top: 16px;" src="@/assets/Mobile/images/QcDigit/programme4.png" alt="">
            <img style="margin-top: 16px;" src="@/assets/Mobile/images/QcDigit/programme5.png" alt="">
        </div>
      </div>
      <div class="programme programme2">
        <div class="sk-mobile-title">
          <div class="title">定制数字人&音色，或使用系统提供的数字人&音色，满足不同场景需求</div>
        </div>
        <div class="content" style="margin-top: 17px;">
            <img src="@/assets/Mobile/images/QcDigit/programme6.png" alt="">
        </div>
      </div>
      <div class="programme programme1">
        <div class="sk-mobile-title">
          <div class="title">灵活驱动方案，支持AI文案、语音驱动数字人</div>
        </div>
        <div class="content" style="margin-top: 24px;">
            <img src="@/assets/Mobile/images/QcDigit/programme7.png" alt="">
        </div>
      </div>
      <div class="programme programme4">
        <div class="sk-mobile-title">
          <div class="title">灵活驱动方案，支持AI文案、语音驱动数字人</div>
        </div>
        <div class="content" style="margin-top: 24px;">
            <img src="@/assets/Mobile/images/QcDigit/programme8.png" alt="">
        </div>
      </div>
      <div class="programme programme1">
        <div class="sk-mobile-title">
          <div class="title">在线预览合成好的视频，一键下载到本地，多渠道发布</div>
        </div>
        <div class="content" style="margin-top: 24px;">
            <img src="@/assets/Mobile/images/QcDigit/programme9.png" alt="">
        </div>
      </div>
      <Case title="微商城" />
      <ContactForm info-sources="千橙数字人" />
      <TryModal v-if="tryVisible" :visible="tryVisible" info-sources="千橙数字人" @cancel="modalClose" />
  
    </div>
  </template>
  
  <script>
  import metaInfo from '@/common/util/metaInfo'
  import ContactForm from '@/Mobile/Mobilecom/ContactForm'
  import Case from '@/Mobile/Mobilecom/Case'
  import TryModal from '@/Mobile/Mobilecom/TryModal'
  
  export default {
    metaInfo: metaInfo.QcDigit,
    components: {
      ContactForm,
      Case,
      TryModal
    },
    data() {
      return {
        tryVisible: false,
        tooItem:'1',
      }
    },
    mounted() {
  
    },
    methods: {
      linkTo(path) {
          this.$router.push({ path: '/m/' + path })
          this.$nextTick(() => {
              this.open = false
          })
      },
      checkBg(item) {
        this.tooItem = item;
      },
      openModal: function() {
        this.tryVisible = true
      },
      modalClose: function(data) {
        this.tryVisible = data
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
  .programme1{
    background: #FFFFFF;
  }
  .programme2{
    background: #F8FCFF;
  }
  .programme3{
    background: #F8FBFF;
  }
  .programme4{
    background: #F9FAFF;
  }
  .banner_box{
    position: absolute;
    top: 25px;
    left:16px;
    .banner_title{
        height: 25px;
        font-size: 18px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 25px;
        text-align: left;
    }
    .banner_title2{
        width: 142px;
        height: 28px;
        font-size: 10px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 14px;
        margin-top: 22px;
        text-align: left
    }
    .banner_line{
        width: 50px;
        height: 3px;
        background: #28DAFB;
        margin-top:6px;
        
    }
    .banner_text{
        margin-top:22px;
        width: 134px;
        height: 78px;
        font-size: 10px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 17px;
        text-align: left
    }
  }
  .banner {
    width: 100%;
    height: 200px;
    margin-top: 50px;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
 
  </style>
  